import { useContext } from 'react';
import { Guid } from 'guid-typescript';

import { ModalWindowApiContext, ModalWindowItem } from './ModalWindowApiContext';

export function useModalWindowApi() {
  const context = useContext(ModalWindowApiContext);

  if (typeof context === 'undefined') {
    throw new Error('useModalWindowApi must be within ModalWindowApiProvider');
  }

  const addModal = (newModal: ModalWindowItem): UUID => {
    return context.add({
      ...newModal,
      id: Guid.create().toString()
    });
  };

  return {
    closeModal: context.close,
    addModal,
    clearAllModal: context.clearAll
  } as const;
}
